import { useMutation } from '@tanstack/react-query';
import {
  editCVVideoById,
  autoModerateById,
  speechModerationId,
  textModerationId,
} from '../services/cvVideosServices';
import CVVideo from '../models/cv-video';
import { AxiosResponse } from 'axios';
import AcceptanceCvVideoDto from '../models/dto/acceptance-cv-video-dto';
import VideoModerationResultDto from '@cv-videos/models/dto/video-moderation-result.dto';
import TextModerationResponseDto from '@cv-videos/models/dto/text-moderation-response.dto';

export const useEditCVVideoByIdMutation = () => {
  const mutation = useMutation<
    AxiosResponse<CVVideo>,
    unknown,
    { id: string; payload: AcceptanceCvVideoDto },
    unknown
  >((mutationVariables) =>
    editCVVideoById(mutationVariables.id, mutationVariables.payload),
  );

  return mutation;
};

export const useContentModerationId = () => {
  const mutation = useMutation<
    AxiosResponse<VideoModerationResultDto>,
    unknown,
    { id: string },
    unknown
  >((mutationVariables) => autoModerateById(mutationVariables.id));

  return mutation;
};

export const useSpeechModerationId = () => {
  const mutation = useMutation<
    AxiosResponse<string[]>,
    unknown,
    { id: string },
    unknown
  >((mutationVariables) => speechModerationId(mutationVariables.id));

  return mutation;
};

export const useTextModerationId = () => {
  const mutation = useMutation<
    AxiosResponse<TextModerationResponseDto[]>,
    unknown,
    { id: string },
    unknown
  >((mutationVariables) => textModerationId(mutationVariables.id));

  return mutation;
};
